module.exports = __webpack_public_path__ + "static/media/grandsiam.5f3e8973.png";